import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { Check, Copy } from 'lucide-react'
import { money } from '../financial/formatting'
import ChannelCard from './ChannelCard'
import ChannelFunnel from './ChannelFunnel'
import EmptyChannel from './EmptyChannel'
import MiniKpi from './MiniKpi'
import { fmtPct } from './model'

// Traffic the partner sends by link. The link itself is always shown, data
// or not - it is what they need to start.
export default function ClicksChannelCard({ block, link, earningsLabel }) {
  const empty = Number(block.clicks || 0) === 0 && Number(block.leads || 0) === 0

  return (
    <ChannelCard id="pw-clicks" channel="clicks" title="Traffic you send by link" block={block} earningsLabel={earningsLabel}>
      {empty ? (
        <EmptyChannel>
          {link
            ? 'Your tracking link is ready — clicks will appear here once traffic starts.'
            : "Your tracking link isn't set up yet — your account manager will share it with you."}
        </EmptyChannel>
      ) : (
        <>
          <ChannelFunnel
            label="Clicks funnel"
            color="var(--channel-clicks)"
            steps={[
              { label: 'Clicks', value: block.clicks },
              { label: 'Leads', value: block.leads },
              { label: 'Sold', value: block.sold },
            ]}
          />
          <div className="pw-minikpis">
            <MiniKpi label="Avg per sold lead" value={money(block.avg_per_sold)} />
            <MiniKpi label="Earnings per click" value={money(block.earnings_per_click)} />
            <MiniKpi label="Click-to-lead" value={fmtPct(block.click_to_lead_pct)} hint="Clicks that ended in a completed form." />
          </div>
        </>
      )}
      {link && <TrackingLink link={link} />}
    </ChannelCard>
  )
}

function TrackingLink({ link }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 1600)
    } catch {
      toast.error("Couldn't copy - select the link and copy it by hand")
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: 'var(--text-muted)', textTransform: 'uppercase' }}>
        Your tracking link
      </span>
      <div className="pw-link-box" style={{ padding: '8px 8px 8px 12px', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg-raised)' }}>
        <code style={{ fontSize: 12, color: 'var(--text-primary)' }} title={link}>{link}</code>
        <button
          type="button"
          onClick={copy}
          className="btn btn-ghost btn-sm"
          aria-label={copied ? 'Link copied' : 'Copy tracking link'}
          style={{ flexShrink: 0 }}
        >
          {copied ? <Check size={13} aria-hidden="true" /> : <Copy size={13} aria-hidden="true" />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Pass your click ID in subid.</span>
    </div>
  )
}
